import { produce } from "immer";
import { requestIsSuccess, requestResponse } from "@redriver/cinnamon";
import { ActionTypes } from "./actions";

const initialState = {
  unreadCount: 0,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.GetUnreadNotificationCount:
      if (requestIsSuccess(action)) {
        return produce(state, (draftState) => {
          draftState.unreadCount = requestResponse(action) || 0;
        });
      }
      return state;
    default:
      return state;
  }
};
